var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from "react";
import { fetchLatestSolrReindexRun, fetchSolrReindexRun, reindexSolr, } from "../api/adminService";
import { toErrorWithResponse } from "../utils/httpErrors";
import { usePolledJob } from "./usePolledJob";
/** sessionStorage key of the reindex run the admin page follows. */
export var SOLR_REINDEX_STORAGE_KEY = "br-agency.solr-reindex-run";
var HTTP_CONFLICT = 409;
var isRunActive = function (run) { return run.status === "RUNNING"; };
/**
 * Starts and follows an asynchronous Solr reindex (DB-876). The start answers
 * HTTP 202 with the run; its progress is polled every 2 s from
 * `GET admin/solr/reindex/{runId}` and the run is remembered in sessionStorage,
 * so the admin can leave the page and come back. When a reindex already runs
 * (HTTP 409, or one started from elsewhere) the page follows that run instead.
 */
export var useSolrReindexRun = function () {
    var polled = usePolledJob({
        storageKey: SOLR_REINDEX_STORAGE_KEY,
        fetchStatus: fetchSolrReindexRun,
        isActive: isRunActive,
    });
    var ky = polled.ky, start = polled.start;
    var attachToLatest = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var latest;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchLatestSolrReindexRun(ky)];
                case 1:
                    latest = _a.sent();
                    if ((latest === null || latest === void 0 ? void 0 : latest.runId) && isRunActive(latest)) {
                        start(latest.runId, latest);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [ky, start]);
    var startRun = useCallback(function (core) { return __awaiter(void 0, void 0, void 0, function () {
        var run, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 5]);
                    return [4 /*yield*/, reindexSolr(ky, core)];
                case 1:
                    run = _c.sent();
                    start(run.runId, run);
                    return [3 /*break*/, 5];
                case 2:
                    error_1 = _c.sent();
                    if (!(((_b = (_a = toErrorWithResponse(error_1)) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status) === HTTP_CONFLICT)) return [3 /*break*/, 4];
                    return [4 /*yield*/, attachToLatest()];
                case 3:
                    _c.sent();
                    return [2 /*return*/];
                case 4: throw error_1;
                case 5: return [2 /*return*/];
            }
        });
    }); }, [ky, start, attachToLatest]);
    return {
        run: polled.state,
        runId: polled.jobId,
        isRunning: polled.isRunning,
        pollFailed: polled.pollFailed,
        retry: polled.retry,
        forgetStored: polled.forgetStored,
        startRun: startRun,
        attachToLatest: attachToLatest,
        reset: polled.reset,
    };
};
